export default __webpack_public_path__ + "f4155836f9d2c1b904d09b7fc4788780.jpg";